const OPERATOR_TYPE_ALIASES = {
  bool: 'boolean',
  booleancheckbox: 'boolean',
};

/**
 * Convert HubSpot property metadata into a type accepted by the operators API.
 * HubSpot represents a single checkbox as type "bool" and fieldType
 * "booleancheckbox", while Distributely's operators API uses "boolean".
 */
export const getOperatorPropertyType = (property) => {
  const rawType = property?.type || property?.dataType || property?.fieldType;
  if (!rawType) return '';

  const normalizedType = String(rawType).trim().toLowerCase();
  return OPERATOR_TYPE_ALIASES[normalizedType] || normalizedType;
};
